// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"389":"af8d951d","463":"af8d951d","567":"3b53517f"}[chunkId] + ".chunk.css";
};